import React from 'react';
import { motion } from 'framer-motion';
import { Star, Award, CheckCircle2 } from 'lucide-react';
export function SocialProofSection() {
  const testimonials = [{
    text: 'En pocos días noté que mi hijo pedía menos el celular. Fue un cambio enorme en casa.',
    author: 'Mariana G., Córdoba'
  }, {
    text: 'Las actividades son simples y funcionan. Ahora tenemos tardes más tranquilas.',
    author: 'Lucas R., Rosario'
  }, {
    text: 'Pensé que sería más de lo mismo, pero realmente marcó la diferencia.',
    author: 'Sofía M., Buenos Aires'
  }, {
    text: 'Mi hijo volvió a concentrarse en sus tareas. Valió cada peso.',
    author: 'Carla P., Mendoza'
  }, {
    text: 'Lo recomiendo totalmente. Es práctico y fácil de aplicar.',
    author: 'Diego M., La Plata'
  }];
  return <section className="py-16 px-4 bg-[#F2F2F2]" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <div className="text-center mb-10" data-id="element-121">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1E3A5F] mb-4" data-id="element-122">
            Más de 10.000 familias ya lo están usando
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-123">
            <div className="flex text-yellow-400" data-id="element-124">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-125" />)}
            </div>
            <span className="font-bold text-[#1E3A5F] text-lg" data-id="element-126">4.9/5</span>
          </div>
          <p className="text-gray-600" data-id="element-127">en satisfacción del cliente</p>
        </div>

        {/* Horizontal Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-128">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-129">
              <div className="flex gap-1 text-yellow-400 mb-2" data-id="element-130">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-3 h-3 fill-current" data-id="element-131" />)}
              </div>
              <p className="text-gray-700 text-sm italic mb-3" data-id="element-132">"{t.text}"</p>
              <p className="text-xs font-bold text-[#1E3A5F]" data-id="element-133">— {t.author}</p>
            </motion.div>)}
        </div>

        {/* Trust Badge */}
        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 max-w-sm mx-auto" data-id="element-134">
          <div className="flex items-center gap-4 mb-3" data-id="element-135">
            <div className="bg-yellow-100 p-3 rounded-full" data-id="element-136">
              <Award className="w-8 h-8 text-yellow-600" data-id="element-137" />
            </div>
            <div data-id="element-138">
              <h3 className="font-bold text-[#1E3A5F] text-lg" data-id="element-139">
                Vendedor Platinum
              </h3>
              <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-140">
                Mercado Líder
              </p>
            </div>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2" data-id="element-141">
            <div className="bg-[#22C55E] h-2.5 rounded-full w-full" data-id="element-142"></div>
          </div>

          <div className="flex items-center gap-2 text-sm font-medium text-[#22C55E]" data-id="element-143">
            <CheckCircle2 className="w-4 h-4" data-id="element-144" />
            <span data-id="element-145">+10.000 ventas verificadas</span>
          </div>
        </div>
      </div>
    </section>;
}